module.exports = __webpack_public_path__ + "static/media/logo.8032af55.png";